import { API_PATH_PREFIX } from '@/services/vehicleDiagnosticsApi';

/**
 * To be used for all the dialogs that will be opened in the parent frontend.
 * The parent frontend (web-workshop) uses this same value to process Dialog related messages.
 * */
export const MFE_DIALOG_PREFIX = 'VEHICLE-DIAGNOSTICS-DIALOGS';

export const WORKSHOPS_ENDPOINT_PATH = `${API_PATH_PREFIX}/workshops`;
export const ASSIGNMENTS_ENDPOINT_PATH = `${API_PATH_PREFIX}/assignments`;

export const WORKSHOPS_DIALOG_PATH = '/dialog/workshop-details';
export const ASSIGNMENTS_DIALOG_PATH = '/dialog/customer-details';

export const BRAKE_LINING_SETTING_API_PATH = `${API_PATH_PREFIX}/user-settings/brake-lining`;
export const TABLE_SETTINGS_DIALOG_PATH = '/dialog/table-settings';

/**
 * Mapping of table identifiers to their corresponding API paths for fetching and saving user settings.
 * The keys should match the diagnosticsTableView route parameter from Router.tsx.
 * The UserSettingsDialog component uses this mapping to determine which API endpoint to call for user settings.
 * */
export const TABLE_TO_API_MAP = {
    'brake-lining': BRAKE_LINING_SETTING_API_PATH,
} as const;

export const TABLE_BRAKE_LINING = 'brake-lining';
export const TABLE_FILL_LEVEL = 'fill-level';
export const TABLE_MAINTENANCE_COMPONENTS = 'maintenance-components';
export const TABLE_TYRE_PRESSURE = 'tyre-pressure';
